import React from 'react'

export const Mission = () => {
  return (
    <section className='mission-section'>
      <img src="/images/mission-vision/mountain.jpg" alt="" />
      <div className='container mission-contain h-100'>
        <div className='row h-100'>
          <div className='col-lg-5'>
            {/* <div className='mission-image'>
              <img src="images/mission-vision/mission.jpg" alt="" />
            </div> */}
          </div>
          <div className='col-lg-7 mission-content'>
            <div>
              <h2>Our Mission</h2>
              <p>Committed to maximize your business growth </p>
              </div>
          </div>
        </div>
      </div>
    </section>
  )
}
